import { StateFromReducersMapObject } from "@reduxjs/toolkit";
import aptServiceReducer from "store/appt/reducers";
import customerServiceReducer from "store/customer/reducers";
import galleryServiceReducer from "store/gallery/reducers";
import notificationServiceReducer from "store/notification/reducers";
import shopServiceReducer from "store/shop/reducers";

const rootReducer = {
  shop: shopServiceReducer,
  apt: aptServiceReducer,
  customer: customerServiceReducer,
  gallery: galleryServiceReducer,
  notification: notificationServiceReducer,
};

export type RootState = StateFromReducersMapObject<typeof rootReducer>;

export default rootReducer;
